import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
  inject,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { DateFnsAdapter } from "@angular/material-date-fns-adapter";
import { enUS } from "date-fns/locale";
import { Observable, catchError, map, of, throwError } from "rxjs";
import {
  ISearchRequest,
  SearchTags,
} from "../../features/models/searchRequest.model";
import { AutoComplete, MultiSelect } from "../models/material-common-models";
import { BucketList } from "../../features/buckets/models/bucket.model";
import {
  IDynamicControlModel,
  ITagDropDownValue,
} from "../../dynamic-controls/dynamic-control-model";
import { BucketsService } from "../../features/buckets/service/buckets.service";
import { HttpErrorResponse } from "@angular/common/http";
import { OverlayPopupService, SpinnerService } from "../../core";
import { BucketItemsComponent } from "../../features/bucket-items/bucket-items.component";
import { DescriptionOverlayComponent } from "../description-overlay/description-overlay.component";
import { ITags } from "../../features/bucket-items/models/bucket-item.model";
import { YearPickerComponent } from "../year-picker/year-picker.component";
import { DataService } from "../../features/bucket-items/service/data.service";
import { GenericExtensionsService } from "../../extensions/generic-extensions-service";
import { IUserInfoResponse } from "../../features/requester-access/models/get-user-info-response.model";
import { MasterDataService } from "../../dynamic-controls/master-data-service";
import { NgClass } from "@angular/common";
import { MatFormField, MatLabel, MatInput, MatError, MatSuffix } from "@angular/material/input";
import { TooltipDisableDirective } from "../custom-directives/tooltip.directive";
import { MultiSelectDropdownComponent } from "../multi-select-dropdown/multi-select-dropdown.component";
import { MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDatepickerToggleIcon, MatDateRangePicker } from "@angular/material/datepicker";
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelContent, MatExpansionPanelTitle } from "@angular/material/expansion";
import { MatSelectTrigger } from "@angular/material/select";
import { MatTooltip } from "@angular/material/tooltip";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatCheckbox } from "@angular/material/checkbox";
import { AutoCompleteComponent } from "../autocomplete/autocomplete.component";
import { MatSlideToggle } from "@angular/material/slide-toggle";

@Component({
    selector: "app-search",
    templateUrl: "./search.component.html",
    styleUrls: ["./search.component.scss"],
    providers: [
        { provide: DateAdapter, useClass: DateFnsAdapter },
        { provide: MAT_DATE_LOCALE, useValue: enUS },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: ["dd-MM-yyyy", "dd-MMM-yyyy", "d-MMM-yyyy", "dd-M-yyyy", "d-MM-yyyy", "d-M-yyyy",
                        "dd MM yyyy", "dd MMM yyyy", "d MMM yyyy", "dd M yyyy", "d MM yyyy", "d M yyyy",
                        " dd  MMM  yyyy", " dd MMM yyyy", "dd  MMM  yyyy", "dd  MMM yyyy", "dd MMM  yyyy", " dd  MMM yyyy", " dd MMM  yyyy",
                        " dd  MM  yyyy", " dd MM yyyy", "dd  MM  yyyy", "dd  MM yyyy", "dd MM  yyyy", " dd  MM yyyy", " dd MM  yyyy"
                    ],
                },
                display: {
                    dateInput: " dd  MMM  yyyy",
                    monthYearLabel: "MMM yyyy",
                    dateA11yLabel: "PP",
                    monthYearA11yLabel: "MMMM yyyy",
                },
            },
        },
    ],
    imports: [NgClass, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, TooltipDisableDirective, MultiSelectDropdownComponent, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatSuffix, MatDatepickerToggleIcon, MatDateRangePicker, MatExpansionPanel, MatExpansionPanelHeader, MatSelectTrigger, MatTooltip, MatExpansionPanelContent, MatExpansionPanelTitle, MatButton, MatIconButton, MatCheckbox, YearPickerComponent, AutoCompleteComponent, MatSlideToggle]
})
export class SearchComponent implements OnInit, AfterViewInit, OnChanges {
  private readonly bucketService = inject(BucketsService);
  private readonly overlayPopupService = inject(OverlayPopupService);
  private readonly spinnerService = inject(SpinnerService);
  private readonly dataService = inject(DataService);
  private readonly genericExtensions = inject(GenericExtensionsService);
  private readonly masterDataService = inject(MasterDataService);
  private readonly cdr = inject(ChangeDetectorRef);

  private readonly controlsService = inject(MasterDataService);
  @Input() public moduleName: string; //Required: With this parameter the values for module will be set and used to fetch data for respective module
  @Input() public bucketList$: Observable<BucketList[]>;
  @Input() public bucketListInput: BucketList[];
  @Input() public contextBucketType: string = "";
  @Input() public contextBuCode: string = "";
  masterTags: IDynamicControlModel[] = [];
  @Output() searchData = new EventEmitter<Partial<ISearchRequest>>();
  @Output() searchToggle = new EventEmitter<boolean>();
  @ViewChildren(YearPickerComponent)
  yearComponents: QueryList<YearPickerComponent>;
  multiSelect: MultiSelect = new MultiSelect();
  bucketList: MultiSelect[] = [];
  buList: MultiSelect[] = [];
  fileTypeTagList: MultiSelect[] = [];
  rawDataTagList: MultiSelect[] = [];
  validityTagList: MultiSelect[] = [];
  yearOfLastEntryTagList: MultiSelect[] = [];
  sourceTagList: MultiSelect[] = [];
  softwareNameTagList: MultiSelect[] = [];
  qualitySystemTagList: MultiSelect[] = [];
  displaySelectedTags: string[] = [];
  page: boolean = true;
  toggled: boolean = false;

  bucketListSelected: MultiSelect[] = [];
  buListSelected: MultiSelect[] = [];
  public bucketsMasterData: BucketList[] = [];
  isSearchClicked: boolean = false;
  isValidBuBucket: boolean = true;
  isTagsShow: boolean = true;
  panelOpenState: boolean = false;
  invalidYearOfLastEntry: boolean = false;
  invalidDate:boolean[]=[];
  yearOfLastEntryFrom: number = 0;
  yearOfLastEntryTo: number = 0;
  public uploadedByUserInfo: AutoComplete[] = [];
  private readonly featureToken = "shared";
  private readonly surfaceToken = "search";

  searchDataForm = new FormGroup({
    Bucket: new FormControl([]),
    BU: new FormControl([]),
    Name: new FormControl(null, [
      Validators.maxLength(100),
      Validators.minLength(3),
    ]),
    Path: new FormControl(null, [
      Validators.maxLength(255),
      Validators.minLength(3),
    ]),
    StudyCompletionDateFrom: new FormControl(),
    StudyCompletionDateTo: new FormControl(),
    ArchivingEndDateFrom: new FormControl(),
    ArchivingEndDateTo: new FormControl(),
    CreatedBetweenFrom: new FormControl(),
    CreatedBetweenTo: new FormControl(),
    CreatedBy: new FormControl(),
    includePreviousVersion: new FormControl(),
  });
  toDisplay: boolean = false;
  searchRequest: Partial<ISearchRequest> = {};
  public searchTags: SearchTags = null;
  searchField: FormControl;
  SearchParams = new FormControl();
  // Set max date to today's UTC date (not local date) to prevent selecting future dates
  MaxDate = (() => {
    const now = new Date();
    return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 23, 59, 59, 999);
  })();
  MaxDateForArchivingEnd = new Date(
    new Date(
      new Date().getFullYear() + 15,
      new Date().getMonth(),
      new Date().getDate()
    ).getTime()
  ); // 1500 years from Today
  MinDate = new Date(new Date("1/1/0001 12:00:00"));

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bucketListInput']) {
      this.refreshBucketOptions(changes['bucketListInput'].currentValue ?? []);
    } else if (changes['contextBucketType'] || changes['contextBuCode']) {
      this.applyBucketContextSelection();
    }
    this.cdr.markForCheck();
  }

  ngOnInit(): void {
    this.addCustomValidation(true);
    this.searchRequest.Tags = [];
    this.spinnerService.show(true);
    this.controlsService.GetMasterData().pipe(
      (data) => {
        data.subscribe((x) => {
          this.masterTags = x.filter(tag => !tag.IsObsolete);
          for (const tag of this.masterTags) {
            const all = tag.TagValues.map((tv) => ({ Code: tv, IsSelected: false }));
            all.sort((a, b) => a.Code.localeCompare(b.Code));
            tag.AllTagDropDownValues = all;
            tag.TagDropDownValues = [...all];
          }
        });
        return data;
      },
      map((controls) =>
        controls.sort((a, b) => a.TagsDisplayOrder - b.TagsDisplayOrder)
      )
    );
    const bucketSource = this.bucketListInput !== undefined
      ? of(this.bucketListInput)
      : (this.bucketList$ ?? this.bucketService.GetBucketList());
    bucketSource.pipe(
      catchError((error: HttpErrorResponse) => {
        this.spinnerService.show(false);
        return throwError(() => new Error(error.message));
      })
    ).subscribe((x) => {
      this.refreshBucketOptions(x);
      this.spinnerService.show(false);
    });

    this.searchDataForm.get('Bucket').valueChanges.subscribe(()=>{
      if(this.bucket.status==="INVALID"){
        this.bucket.setErrors({ atLeastOneSelected: true });
      }
      else{
        this.bucket.setErrors(null);
      }
     })

    this.registerDateRangeValidation(
      this.studyCompletionDateFrom,
      this.studyCompletionDateTo,
      0
    );
    this.registerDateRangeValidation(
      this.createdBetweenFrom,
      this.createdBetweenTo,
      2
    );
    this.registerDateRangeValidation(
      this.archivingEndDateFrom,
      this.archivingEndDateTo,
      4
    );
  }

  private registerDateRangeValidation(
    startControl: FormControl,
    endControl: FormControl,
    invalidDateIndex: number
  ): void {
    const validateRange = () =>
      this.validateDateRange(startControl, endControl, invalidDateIndex);

    startControl.valueChanges.subscribe(validateRange);
    endControl.valueChanges.subscribe(validateRange);
  }

  private validateDateRange(
    startControl: FormControl,
    endControl: FormControl,
    invalidDateIndex: number
  ): void {
    const startHasInputError = this.hasNativeDateError(startControl);
    const endHasInputError = this.hasNativeDateError(endControl);

    this.setControlError(startControl, "specialCharacterError", startHasInputError);
    this.setControlError(endControl, "specialCharacterError", endHasInputError);

    const startDate = this.asValidDate(startControl.value);
    const endDate = this.asValidDate(endControl.value);
    const startIsAfterEnd =
      !startHasInputError &&
      !endHasInputError &&
      startDate !== null &&
      endDate !== null &&
      startDate.getTime() > endDate.getTime();

    // The range error belongs to the start control, but it must be recalculated
    // whenever either input changes so a corrected manual entry clears it.
    this.setControlError(startControl, "startDateGreater", startIsAfterEnd);
    this.invalidDate[invalidDateIndex] = startHasInputError;
    this.invalidDate[invalidDateIndex + 1] = endHasInputError;
  }

  private hasNativeDateError(control: FormControl): boolean {
    return Object.keys(control.errors ?? {}).some(
      (key) =>
        key !== "startDateGreater" &&
        key !== "specialCharacterError" &&
        key !== "matStartDateInvalid" &&
        key !== "matEndDateInvalid"
    );
  }

  private asValidDate(value: unknown): Date | null {
    return value instanceof Date && !Number.isNaN(value.getTime()) ? value : null;
  }

  private setControlError(
    control: FormControl,
    errorName: string,
    hasError: boolean
  ): void {
    const errors = { ...(control.errors ?? {}) };
    if (hasError) {
      errors[errorName] = true;
    } else {
      delete errors[errorName];
    }
    control.setErrors(Object.keys(errors).length > 0 ? errors : null);
  }

  public filterTagValues(tag: IDynamicControlModel, searchValue: string) {
    const s = (searchValue || "").toLowerCase();
    if (!tag.AllTagDropDownValues) {
      tag.TagDropDownValues = [];
      return;
    }
    tag.TagDropDownValues = tag.AllTagDropDownValues.filter((x) =>
      x.Code.toLowerCase().includes(s)
    );
  }

  public clearSearchInput(tag: IDynamicControlModel, ev: Event): void {
    ev.stopPropagation();
    ev.preventDefault();
      const target = ev.target as HTMLElement;
      const field = target.closest('mat-form-field');
      const input = field?.querySelector('input');
      if (input) {
        input.value = '';
      }
    this.filterTagValues(tag, '');
  }

  ngAfterViewInit() {
    if (this.yearComponents && this.yearComponents.length > 0) {
      this.yearComponents.forEach((yearComponent) => {
        yearComponent.setParent(this);
      });
    }
      this.cdr.detectChanges();
  }

  clearYearOfEntry(event: Event) {
    if (this.yearComponents && this.yearComponents.length > 0) {
      this.yearComponents.forEach((yearComponent) => {
        yearComponent.ngOnInit();
      });
    }
    this.displaySelectedTags = this.displaySelectedTags.filter(
      (y) => y !== this.yearOfLastEntryFrom.toString()
    );
    this.displaySelectedTags = this.displaySelectedTags.filter(
      (y) => y !== this.yearOfLastEntryTo.toString()
    );
    this.invalidYearOfLastEntry = false;
    event.preventDefault();
  }

  setTagValueFrom(selectedTag: Partial<ITags>) {
    if (selectedTag.TagValue !== "") {
      this.yearOfLastEntryFrom = Number(selectedTag.TagValue);
    } else {
      this.yearOfLastEntryFrom = 0;
    }
    if (
      !(
        this.yearOfLastEntryFrom < this.yearOfLastEntryTo &&
        this.yearOfLastEntryFrom !== 0
      )
    ) {
      this.invalidYearOfLastEntry = true;
    } else {
      this.invalidYearOfLastEntry = false;
    }
  }

  setTagValueTo(selectedTag: Partial<ITags>) {
    if (selectedTag.TagValue !== "") {
      this.yearOfLastEntryTo = Number(selectedTag.TagValue);
    } else {
      this.yearOfLastEntryTo = 0;
    }
    if (
      !(
        this.yearOfLastEntryFrom <= this.yearOfLastEntryTo &&
        this.yearOfLastEntryFrom !== 0
      )
    ) {
      this.invalidYearOfLastEntry = true;
    } else {
      this.invalidYearOfLastEntry = false;
    }
  }

  public toggleData() {
    this.toDisplay = !this.toDisplay;
    this.searchToggle.emit(this.toDisplay);
  }

  addCustomValidation(clearSearch: boolean) {
    this.bucket.setValidators([
      (control: FormControl) => {
        const selectedItems = control.value;
        return (Array.isArray(selectedItems) && selectedItems.length > 0) ||
          clearSearch
          ? null
          : { atLeastOneSelected: true };
      },
    ]);
  }

  public bucketNames() {
    let index = 0;
    for (const bucket of this.bucketsMasterData) {
      for (const item of bucket.Buckets) {
        this.multiSelect.Name = item.BucketType;
        this.multiSelect.displayText = this.getBucketDisplayName(item.BucketType);
        this.multiSelect.id = index + 1;
        this.bucketList.push(this.multiSelect);
        this.multiSelect = new MultiSelect();
        index = index + 1;
      }
    }
    this.bucketList = this.bucketList.filter(
      (i, j, arr) => arr.findIndex((t) => t.displayText === i.displayText) === j
    );
  }

  public getBucketDisplayName(bucketName:string):string{
    return this.genericExtensions.getBucketDisplayName(bucketName);
 }

  public buNames() {
    let index = 0;
    for (const bucket of this.bucketsMasterData.filter((x: BucketList) => x.BUCode !== "")) {
      this.multiSelect.Name = bucket.BUCode;
      this.multiSelect.displayText = bucket.BUCode;
      this.multiSelect.id = index + 1;
      this.buList.push(this.multiSelect);
      this.multiSelect = new MultiSelect();
      index = index + 1;
    }
    this.buList = this.buList.filter(
      (i, j, arr) => arr.findIndex((t) => t.displayText === i.displayText) === j
    );
  }

  public tags() {
    this.masterTags.forEach((tags) => {
      tags.TagValues.forEach((tagValue, index) => {
        this.multiSelect.Name = tagValue;
        this.multiSelect.displayText = tagValue;
        this.multiSelect.id = index + 1;
        if (tags.TagKey === "File Type") {
          this.fileTypeTagList.push(this.multiSelect);
        } else if (tags.TagKey === "Raw Data") {
          this.rawDataTagList.push(this.multiSelect);
        } else if (tags.TagKey === "Validity") {
          this.validityTagList.push(this.multiSelect);
        } else if (tags.TagKey === "Year Of Last Entry") {
          this.yearOfLastEntryTagList.push(this.multiSelect);
        } else if (tags.TagKey === "Source") {
          this.sourceTagList.push(this.multiSelect);
        } else if (tags.TagKey === "Software Name") {
          this.softwareNameTagList.push(this.multiSelect);
        } else if (tags.TagKey === "Quality System") {
          this.qualitySystemTagList.push(this.multiSelect);
        }
        this.multiSelect = new MultiSelect();
      });
    });
  }

  public prePopulateDropdown() {
    if (this.bucketList.length === 0) {
      this.bucketNames();
    }
    if (this.buList.length === 0) {
      this.buNames();
    }
    if (
      this.fileTypeTagList.length === 0 ||
      this.rawDataTagList.length === 0 ||
      this.validityTagList.length === 0 ||
      this.yearOfLastEntryTagList.length === 0 ||
      this.sourceTagList.length === 0 ||
      this.softwareNameTagList.length === 0 ||
      this.qualitySystemTagList.length === 0
    ) {
      this.tags();
    }
    this.applyBucketContextSelection();
  }

  private refreshBucketOptions(bucketData: BucketList[]): void {
    this.bucketsMasterData = bucketData;
    this.bucketList = [];
    this.buList = [];
    this.bucketNames();
    this.buNames();
    this.prePopulateDropdown();
  }

  private applyBucketContextSelection(): void {
    const selectedBucketType = this.contextBucketType || BucketItemsComponent.BucketType;
    if (selectedBucketType !== "") {
      this.page = false;
      this.searchDataForm.controls.BU.disable();
      this.searchDataForm.controls.Bucket.disable();
      let bucketItem = this.bucketList.find(
        (x) => x.Name?.toLowerCase() === selectedBucketType.toLowerCase()
      );
      if (!bucketItem) {
        bucketItem = {
          id: this.bucketList.length + 1,
          Name: selectedBucketType,
          displayText: this.getBucketDisplayName(selectedBucketType),
        } as MultiSelect;
        this.bucketList = [...this.bucketList, bucketItem];
      }
      this.bucket.setValue([bucketItem], { emitEvent: false });
      this.bucketListSelected = [bucketItem];
    }

    const selectedBuCode = this.contextBuCode || BucketItemsComponent.BuCode;
    if (selectedBuCode !== "") {
      let buItem = this.buList.find(
        (x) => x.Name?.toLowerCase() === selectedBuCode.toLowerCase()
      );
      if (!buItem) {
        buItem = {
          id: this.buList.length + 1,
          Name: selectedBuCode,
          displayText: selectedBuCode,
        } as MultiSelect;
        this.buList = [...this.buList, buItem];
      }
      this.bu.setValue([buItem], { emitEvent: false });
      this.buListSelected = [buItem];
    }
  }

  get name() {
    return this.searchDataForm.controls.Name.value;
  }

  get path() {
    return this.searchDataForm.controls.Path.value;
  }

  get bucket() {
    return this.searchDataForm.controls.Bucket;
  }

  get bu() {
    return this.searchDataForm.controls.BU;
  }

  get studyCompletionDateFrom() {
    return this.searchDataForm.controls.StudyCompletionDateFrom;
  }

  get studyCompletionDateTo() {
    return this.searchDataForm.controls.StudyCompletionDateTo;
  }

  get createdBetweenFrom() {
    return this.searchDataForm.controls.CreatedBetweenFrom;
  }

  get createdBetweenTo() {
    return this.searchDataForm.controls.CreatedBetweenTo;
  }

  get archivingEndDateFrom() {
    return this.searchDataForm.controls.ArchivingEndDateFrom;
  }

  get archivingEndDateTo() {
    return this.searchDataForm.controls.ArchivingEndDateTo;
  }

  get createdBy() {
    return this.searchDataForm.controls.CreatedBy.value;
  }

  public validateItems() {
    if (
      this.bucket.value.some((x:MultiSelect) => x.Name === "StudyDataCollection") &&
      this.bucket.value.length === 1 &&
      this.bu.value.length > 0
    ) {
      this.isValidBuBucket = false;
    } else {
      this.isValidBuBucket = true;
    }
  }

  public onBusinessUnitCleared(): void {
    this.buListSelected = [];
    this.validateItems();
  }

  clearSearchWithData(column: IDynamicControlModel, event: Event) {
    event.preventDefault();
    column.TagDropDownValues.forEach((x: ITagDropDownValue) => {
      x.IsSelected = false;
    });
    column.TagDropDownValues.forEach((x: ITagDropDownValue) => {
      this.displaySelectedTags = this.displaySelectedTags.filter(
        (y) => y !== x.Code
      );
    });
  }

  panelClose() {
    this.displaySelectedTags = [];
    this.masterTags.forEach((x) => {
      x.TagDropDownValues.forEach((y) => {
        if (y.IsSelected === true) {
          this.displaySelectedTags.push(y.Code.replace(/\s/g, ""));
        }
      });
    });
    if (this.yearOfLastEntryFrom.toString() !== "0") {
      this.displaySelectedTags.push(this.yearOfLastEntryFrom.toString());
    }
    if (this.yearOfLastEntryTo.toString() !== "0") {
      this.displaySelectedTags.push(this.yearOfLastEntryTo.toString());
    }
    if (this.displaySelectedTags[0] ? true : false) {
      this.isTagsShow = false;
    }
  }

  panelOpen() {
    this.isTagsShow = true;
  }

  closePanel() {
    if (!(this.isSearchClicked && this.invalidYearOfLastEntry)) {
      this.panelOpenState = false;
    } else {
      this.panelOpenState = true;
    }
  }

  openPanel(event: Event) {
    event.stopPropagation();
  }

  onSearchClick() {
    this.addCustomValidation(false);
    this.closePanel();
    this.isSearchClicked = true;
    if (this.bucket.value.length === 0) {
      this.bucketListSelected=[];
      this.bucket.setErrors({ atLeastOneSelected: true });
    }
    if (this.invalidYearOfLastEntry || this.invalidDate.some(x=>x===true)) {
      return;
    }
    if (this.isValidBuBucket === true) {
      if (
        this.studyCompletionDateFrom.value &&
        !this.studyCompletionDateTo.value
      ) {
        this.studyCompletionDateTo.setValue(this.MaxDate);
      } else if (
        !this.studyCompletionDateFrom.value &&
        this.studyCompletionDateTo.value
      ) {
        this.studyCompletionDateFrom.setValue(this.MinDate);
      }
      if (
        this.studyCompletionDateFrom.value >
        this.studyCompletionDateTo.value
      ) {
        this.studyCompletionDateFrom.setErrors({ startDateGreater: true });
      }

      if (
        this.createdBetweenFrom.value &&
        !this.createdBetweenTo.value
      ) {
        this.createdBetweenTo.setValue(this.MaxDate);
      } else if (
        !this.createdBetweenFrom.value &&
        this.createdBetweenTo.value
      ) {
        this.createdBetweenFrom.setValue(this.MinDate);
      }
      if (
        this.createdBetweenFrom.value >
        this.createdBetweenTo.value
      ) {
        this.createdBetweenFrom.setErrors({ startDateGreater: true });
      }

      if (
        this.archivingEndDateFrom.value &&
        !this.archivingEndDateTo.value
      ) {
        this.archivingEndDateTo.setValue(this.MaxDateForArchivingEnd);
      } else if (
        !this.archivingEndDateFrom.value &&
        this.archivingEndDateTo.value
      ) {
        this.archivingEndDateFrom.setValue(this.MinDate);
      }
      if (
        this.archivingEndDateFrom.value >
        this.archivingEndDateTo.value
      ) {
        this.archivingEndDateFrom.setErrors({ startDateGreater: true });
      }
      if (this.searchDataForm.valid && this.bucketListSelected[0]) {
        this.isSearchClicked = false;
        this.setSearchValues();
        this.searchData.emit(this.searchRequest);
      }
    }
  }

  onClearSearchClick() {
    this.dataService.setClearSearch(true);
    this.isSearchClicked = false;
    this.toggled = false;
    this.markBucketAsUntouched();
    this.addCustomValidation(true);
    if (BucketItemsComponent.BucketType === "") {
      this.bucketListSelected = [];
      this.buListSelected = [];
      this.searchDataForm.patchValue({
        Bucket: [],
        BU: [],
        Name: null,
        Path: null,
        CreatedBy: null,
        CreatedBetweenFrom: null,
        CreatedBetweenTo: null,
        StudyCompletionDateFrom: null,
        StudyCompletionDateTo: null,
        ArchivingEndDateFrom: null,
        ArchivingEndDateTo: null,
      });
    } else {
      this.searchDataForm.patchValue({
        Name: null,
        Path: null,
        CreatedBy: null,
        CreatedBetweenFrom: null,
        CreatedBetweenTo: null,
        StudyCompletionDateFrom: null,
        StudyCompletionDateTo: null,
        ArchivingEndDateFrom: null,
        ArchivingEndDateTo: null,
      });
    }

    this.masterTags.forEach((tag) => {
      tag.TagDropDownValues = [];
      tag.TagValues.forEach((tagValues) => {
        tag.TagDropDownValues.push({ Code: tagValues, IsSelected: false });
      });
    });
    this.displaySelectedTags = [];

    this.toggled = false;
    this.searchDataForm.controls["includePreviousVersion"].setValue(false);
    this.setSearchValues();
    this.validateItems();
  }

  public markBucketAsUntouched() {
    this.bucket.markAsUntouched();
  }

 private setSearchValues() {
  this.bucketListSelected = this.bucket.value;
  this.buListSelected = this.bu.value;

  this.searchRequest.BucketType = this.bucket.value.map((b: MultiSelect) => b.Name);
  this.searchRequest.BUCode = this.bu.value.map((b: MultiSelect) => b.Name);

  const tagMap: Record<string, string[]> = {
    "File Type": [],
    "Raw Data": [],
    "Validity": [],
    "Year Of Last Entry": [],
    "Countries": [],
    "Source": [],
    "Software Name": [],
    "Quality System": []
  };

  this.masterTags.forEach(tagGroup => {
  switch (tagGroup.TagKey) {
    case "Year Of Last Entry":
      if (this.yearOfLastEntryFrom !== 0 && this.yearOfLastEntryTo !== 0) {
        for (let i = Number(this.yearOfLastEntryFrom); i <= Number(this.yearOfLastEntryTo); i++) {
          tagMap["Year Of Last Entry"].push(i.toString());
        }
      }
      break;
    default:
      tagGroup.TagDropDownValues
        .filter(t => t.IsSelected)
        .forEach(t => tagMap[tagGroup.TagKey]?.push(t.Code));
  }
});

  this.searchRequest.Tags = Object.entries(tagMap)
    .filter(([_, values]) => values.length > 0)
    .map(([key, values]) => ({ TagKey: key, TagValue: values }));

  this.searchRequest.ArchivingStartDate = this.archivingEndDateFrom.value ?? undefined;
  this.searchRequest.ArchivingEndDate = this.archivingEndDateTo.value ?? undefined;
  this.searchRequest.CreatedStartDate = this.createdBetweenFrom.value ?? undefined;
  this.searchRequest.CreatedEndDate = this.createdBetweenTo.value ?? undefined;
  this.searchRequest.StudyCompletionStartDate = this.studyCompletionDateFrom.value ?? undefined;
  this.searchRequest.StudyCompletionEndDate = this.studyCompletionDateTo.value ?? undefined;

  const matchedUser = this.uploadedByUserInfo?.find(
    x => x.DisplayTextForSelectedValue?.toLowerCase() === this.createdBy?.toLowerCase()
  );
  this.searchRequest.CreatedBy = matchedUser?.SelectedValue ?? this.createdBy;

  this.searchRequest.Name = this.name;
  this.searchRequest.Path = this.path;
  this.searchRequest.IncludePreviousVersions = this.toggled;
}


  public getUserInfo(event:string){
    if(event?.length>2){
        this.getUserInfoResults(event);
    }
}

public getUserInfoResults(value:string){
  this.masterDataService
    .GetUserInfo(value)
    .pipe(
      map((res: IUserInfoResponse[]) => {
      if(res){
        let userInfos:AutoComplete[]=[];
        for(let i=0;i<res.length;i++){
           let userInfo: AutoComplete = {Id:i,DisplayTextForSelectedValue:res[i].Name,SelectedValue:res[i].PUID,SuggestionText:res[i].UserInfo};
            userInfos.push(userInfo);
          }
          this.uploadedByUserInfo = [...userInfos.sort((a, b) => a.DisplayTextForSelectedValue.localeCompare(b.DisplayTextForSelectedValue))];
        }else{
          this.uploadedByUserInfo = [...[]];
        }
      }),
      catchError(() => {
        this.uploadedByUserInfo = [...[]];
        return of([]);
      })
    )
    .subscribe();
}

  overlaydisplay(displaySelectedTags: string[], event: any) {
    event.stopPropagation();
    this.overlayPopupService.open(DescriptionOverlayComponent, {
      data: displaySelectedTags,
      element: event,
      displayPointer: true,
    });
  }

  public buildSearchId(element: string, context?: string | number): string {
    const tokens = [
      this.featureToken,
      this.slugify(this.moduleName || 'global'),
      this.surfaceToken,
      this.slugify(element),
    ];
    if (context !== undefined && context !== null) {
      tokens.push(this.formatContext(context));
    }
    return tokens.join('-');
  }

  private formatContext(value: string | number): string {
    if (typeof value === 'number') {
      return value.toString().padStart(2, '0');
    }
    return this.slugify(value);
  }

  private slugify(value: string): string {
    return (value || 'na')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }
}

export interface DropdownParameters {
  fieldName: string;
  dataType: "text" | "date";
}
